export const MENU_ID = {
  NOTICE: 'notice',
  FAQ: 'question',
  BLOG: 'blog',
}

export interface IBlogPostListSection {
  posts?: IPost[]
  fetchFunction?
  cacheKey?
  menuId?
  subMenuId?
  isMobile
  menuForm?
}
export interface IBlogComponent {
  isMobile
  menuId?
  subMenuId?
}

export interface IBlogIndex {
  seoData: ISeoData
  ogData: IOgData
}

export interface IBlogTag {
  ogData: IOgData
  seoData: ISeoData
  isMobileServer: boolean
}

export interface IBlogDetail {
  post: IPost
  ogData: IOgData
  seoData: ISeoData
  isMobileServer: boolean
}

export interface IOgData {
  title: string
  desc: string
  image: string
  ogUrl: string
}
export interface ISeoData {
  pageTitle: string
  pageDescription: string
  pageKeywords: string
}
export interface IPostQuery {
  data: IPost
  isFetching: boolean
}

export interface IMenuQuery {
  data: IMenu
}
export interface ISubMenuQuery {
  data: ISubMenu
}
export interface IMainPostDataQuery {
  data: IMainPostData
  isFetching: boolean
}

export interface IMainPostData {
  thumbnail: Thumbnail
  _rev: string
  _type: string
  _id: string
  _updatedAt: Date
  metaData: MetaData
  _createdAt: Date
  mainPost: MainPost
  referenceSlug: ReferenceSlug
}

export interface MainPost {
  title: string
  subtitle: string
  thumbnail: Thumbnail
  subMenuCategory: ReferenceSlug
  tagLists: string[]
  category: string
  subCategory: string
  slug: Slug
}

export interface ReferenceSlug {
  _ref: string
  _type: string
}

export interface IPost {
  category: string
  subCategory: string
  subtitle: string
  thumbnail: Thumbnail
  title: string
  metaData: MetaData
  subMenuCategory: SubMenuCategory
  slug: Slug
  publishedAt: Date
  tagLists: string[]
  menuForm: keyof typeof MENU_ID
  isForB2BPost?: boolean
  recommendList: any
  tagList: any
  ctaList: any
  ctaSection: any
  content: any
}

export interface MetaData {
  metaDescription: string
  metaKeyword: string
  metaTitle: string
  _type: string
  ogTitle: string
  ogDescription: string
}

export interface Slug {
  current: string
  _type: string
}

export interface SubMenuCategory {
  _ref: string
  _type: string
}

export interface Thumbnail {
  asset: SubMenuCategory
  _type: string
  alt: string
}
interface IMenu {
  description: string
  _id: string
  id: number
  title: string
  _updatedAt: Date
  _createdAt: Date
  _rev: string
  _type: string
}

interface ISubMenu {
  _rev: string
  _type: string
  description: string
  id: number
  _updatedAt: Date
  _createdAt: Date
  _id: string
  title: string
  menuCategory: MenuCategory
}
export interface MenuCategory {
  _ref: string
  _type: string
}
